import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import './Forums.css';
import { supabase } from '../../config/supabase';

/* =======================
   NETWORK CARD
======================= */
const NetworkCard = ({
    icon,
    title,
    description,
    onClick,
    linkText,
    isHighlight = false
}) => {
    const [isExpanded, setIsExpanded] = useState(false);

    return (
        <div className={`network-option-card ${isHighlight ? 'highlight-card' : ''}`}>
            <div className="card-header-icon">{icon}</div>

            <h3>
                {title}
                {title === 'Expert Engagement' && (
                    <span className="new-tag-small">New</span>
                )}
            </h3>

            <p className={`card-description ${isExpanded ? 'expanded' : 'clamped'}`}>
                {description}
            </p>

            <button
                className="read-more-btn"
                onClick={() => setIsExpanded(p => !p)}
            >
                {isExpanded ? 'Read Less' : 'Read More'}
            </button>

            <button className="network-link" onClick={onClick}>
                {linkText}
            </button>
        </div>
    );
};

/* =======================
   MAIN PAGE
======================= */
const ProfessionalNetwork = () => {
    const navigate = useNavigate();
    const { user, loading: authLoading } = useAuth();

    const [headerContent, setHeaderContent] = useState({
        title: 'Professional Network',
        subtitle: 'Connect with peers, mentors, and industry leaders.',
        bgImage:
            'https://images.unsplash.com/photo-1521737604893-d14cc237f11d?auto=format&fit=crop&q=80'
    });

    useEffect(() => {
        const fetchContent = async () => {
            try {
                const { data, error } = await supabase
                    .from('page_sections')
                    .select('*')
                    .eq('page_slug', 'network')
                    .eq('section_name', 'hero')
                    .single();

                if (data && !error) {
                    setHeaderContent(prev => ({
                        ...prev,
                        ...data.content
                    }));
                }
            } catch (err) {
                console.warn('Network CMS not found, using defaults');
            }
        };

        fetchContent();
    }, []);

    /* Login redirect handler - uses Supabase Auth */
    const requireLogin = (targetPath) => {
        if (authLoading) return; // Wait for auth to load
        
        if (!user) {
            navigate('/login', {
                state: { from: targetPath }
            });
        } else {
            navigate(targetPath);
        }
    };

    return (
        <div className="network-page-single">
            <div className="network-layout">

                <div
                    className="network-hero-panel"
                    style={{
                        backgroundImage: `
                            linear-gradient(rgba(10,45,82,.9), rgba(10,45,82,.8)),
                            url(${headerContent.bgImage})
                        `
                    }}
                >
                    <h1>{headerContent.title}</h1>
                    <p className="network-subtitle">{headerContent.subtitle}</p>
                </div>

                <div className="network-content-panel">
                    <div className="network-options-grid">

                        <NetworkCard
                            icon="&#x1F4AC;"
                            title="Pharma Forums"
                            description="Validated expert discussions."
                            onClick={() => requireLogin('/forums')}
                            linkText="Go to Forums &rarr;"
                        />

                        <NetworkCard
                            icon="&#x1F4C5;"
                            title="Events"
                            description="Industry events & conferences."
                            onClick={() => requireLogin('/events')}
                            linkText="See Events &rarr;"
                            isHighlight
                        />

                        <NetworkCard
                            icon="&#x1F3C6;"
                            title="Expert Engagement"
                            description="Live expert Q&A."
                            onClick={() => requireLogin('/calendar')}
                            linkText="View Calendar &rarr;"
                        />

                        <NetworkCard
                            icon="&#x1F91D;"
                            title="Career Counseling"
                            description="Private mentoring sessions."
                            onClick={() => requireLogin('/session')}
                            linkText="Book Session &rarr;"
                        />

                    </div>
                </div>
            </div>
        </div>
    );
};

export default ProfessionalNetwork;
